import { post } from "services/intelligence/AXIOS"
import { STATS_API, LOCATION_STATS, COMPARISON_API } from "./CONSTANTS"

export const getStats = body => post(STATS_API, body)

export const getLocationStats = () => post(LOCATION_STATS)

export const getComparisonInsights = body => post(COMPARISON_API, body)
